import React__default from 'react';
import styled from 'styled-components';

const StyledAsset = styled.svg.withConfig({
  componentId: "sg1510__sc-1072beb-0"
})(["display:block;overflow:visible;max-width:100%;"]);
const createAssetComponent = (Svg, displayName) => {
  const Component = _ref => {
    let {
      ariaLabel,
      className
    } = _ref;
    return /*#__PURE__*/React__default.createElement(StyledAsset, {
      "aria-label": ariaLabel,
      as: Svg,
      className: className
    });
  };
  Component.displayName = displayName;
  return Component;
};

export { createAssetComponent };
